// Intercom's install snippet without its wait for `window.onload` (the app has loaded by the time it boots):
// queue the calls made before the widget arrives, then load it.
export function loadIntercomWidget(appId: string): void {
	if (typeof window.Intercom !== 'function') {
		const queue: unknown[][] = [];
		const intercom = (...args: unknown[]) => {
			queue.push(args);
		};
		intercom.q = queue;
		intercom.c = (args: unknown[]) => {
			queue.push(args);
		};
		window.Intercom = intercom;
	}

	const script = document.createElement('script');
	script.async = true;
	script.src = `https://widget.intercom.io/widget/${appId}`;
	document.head.appendChild(script);
}
